const parallaxCarouselModule = [
    {
        selector: '[data-react="parallaxCarouselModule"]',
        path: { filename: 'App' },
    },
];

export { parallaxCarouselModule };
